<select [(ngModel)]="enabled" (ngModelChange)="setEnabled()" name="enabled">
  <option value="">ALL</option>
  <option value="true">ENABLED</option>
  <option value="false">DISABLED</option>
</select>
